import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad7ABlue7BBlue = () => <CrossRoad coords="1601.000000, 1142.000000"/>;
export default CrossRoad7ABlue7BBlue;
